import { render, staticRenderFns } from "./PayLink.vue?vue&type=template&id=c54fa41a&scoped=true&"
import script from "./PayLink.vue?vue&type=script&lang=js&"
export * from "./PayLink.vue?vue&type=script&lang=js&"
import style0 from "./PayLink.vue?vue&type=style&index=0&id=c54fa41a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c54fa41a",
  null
  
)

export default component.exports